import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  TemplateRef
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import * as maptilerClient from '@maptiler/client';
import { StorageService } from '../../@services/front/storage.service';

@Component({
  selector: 'vw-location-input',
  templateUrl: './location-input.component.html',
  styleUrls: ['./location-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LocationInputComponent),
      multi: true
    }
  ],
  imports: [
    FormsModule,
    NgClass,
    TranslateModule,
    NgTemplateOutlet
  ]
})
export class LocationInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = 'Entrez une ville, commune ou code postal';
  @Input() disabled: boolean = false;
  @Input() isError: boolean = false;
  @Input() prefix!: TemplateRef<any>;
  @Input() suffix!: TemplateRef<any>;
  @Output() valueChange = new EventEmitter<string>();
  @Output() suggestionSelected = new EventEmitter<string>();
  @Input() value: string = '';
  suggestions: any[] = [];
  showDropdown = false;
  private searchSubject = new Subject<string>();

  constructor(private storageService: StorageService, private changeDetectorRef: ChangeDetectorRef) {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => this.searchLocation(query))
    ).subscribe(results => {
      this.suggestions = results;
      this.showDropdown = results.length > 0;
      this.changeDetectorRef.detectChanges();
    });
    maptilerClient.config.apiKey = environment.MAP_TILER_KEY;
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
    this.onTouched();
    this.valueChange.emit(this.value);

    if (this.value.length > 2) {
      this.searchSubject.next(this.value);
    }/* else {
      this.suggestions = [];
      this.showDropdown = false;
    }*/
  }

  searchLocation(query: string) {
    return maptilerClient.geocoding.forward(query, {
      language: this.storageService.getCurrentLanguage().toLowerCase(),
      types: ['municipality', 'place'], // communes, villages
      country: ['BE', 'FR', 'NL', 'ES', 'IT', 'DE', 'GB']
    }).then(response => {
      return response.features;
    });
  }

  selectSuggestion(suggestion: any) {
    this.value = suggestion.name;
    this.suggestions = [];
    this.showDropdown = false;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
    this.suggestionSelected.emit(suggestion);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChange = (value: string) => { };
  onTouched = () => { };
}
